import { render, staticRenderFns } from "./LxNumberfield.vue?vue&type=template&id=7839d346"
import script from "./LxNumberfield.vue?vue&type=script&lang=js"
export * from "./LxNumberfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports